function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 26");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Chile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tarjetas_perfil_empty",
  transform: "translate(-1117.000000, -517.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-26",
  transform: "translate(1120.000000, 520.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#D8D8D8",
  strokeWidth: 5,
  x: 0,
  y: 0,
  width: 97,
  height: 65,
  rx: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.0703125,
  y1: 16.5,
  x2: 94,
  y2: 16.5,
  id: "Path-10",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.0703125,
  y1: 24.5,
  x2: 94,
  y2: 24.5,
  id: "Path-10-Copy-4",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.5292969,
  y1: 48,
  x2: 67,
  y2: 48,
  id: "Path-10-Copy-5",
  stroke: "#979797",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#979797",
  cx: 73.5,
  cy: 47.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-5",
  fill: "#979797",
  cx: 80.5,
  cy: 47.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-6",
  fill: "#979797",
  cx: 87.5,
  cy: 47.5,
  r: 1.5
}))));

var SvgIcNoCreditCard = function SvgIcNoCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103px",
    height: "71px",
    viewBox: "0 0 103 71",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNoCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_no_credit_card.f01ffce2.svg";
export { ForwardRef as ReactComponent };